<div class="pt-[1px] px-4 md:px-8 pb-8 max-w-8xl mx-auto space-y-8 animate-fade-in font-sans text-slate-800">

  <!-- NEW PROFESSIONAL BACK BUTTON -->
  <a [routerLink]="['/admin-dashboard']" 
     [queryParams]="{ tab: 'accounts' }"
     class="inline-flex items-center gap-2 mb-6 px-4 py-2.5 bg-white hover:bg-slate-50 border border-slate-200 rounded-lg shadow-sm text-slate-600 text-sm font-semibold transition-all hover:text-slate-900 hover:border-slate-300 group cursor-pointer print:hidden">
      <svg class="w-4 h-4 transition-transform group-hover:-translate-x-1 text-slate-400 group-hover:text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
      </svg>
      <span>Back to Dashboard</span>
  </a>

  <!-- HEADER & FILTERS -->
  <div class="bg-white p-6 rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100">
    <div class="flex flex-col lg:flex-row gap-6 items-end justify-between">
      
      <!-- Firm Selection -->
      <div class="w-full lg:w-64 space-y-2">
        <label class="text-xs font-bold text-gray-400 uppercase tracking-wider ml-1">Select Firm</label>
        <div class="relative">
          <select class="appearance-none bg-none w-full bg-gray-50 border border-gray-200 hover:border-yellow-500 text-gray-700 text-sm rounded-xl px-4 py-3 pr-8 focus:outline-none focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 transition-all cursor-pointer font-medium">
            <option>All Firms</option>
            <option>Apex Holdings</option>
            <option>Global Ventures</option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-400">
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Period Toggle -->
      <div class="w-full lg:w-auto flex flex-col space-y-2">
         <label class="text-xs font-bold text-gray-400 uppercase tracking-wider ml-1">Time Period</label>
         <div class="bg-gray-100 p-1 rounded-xl inline-flex w-full lg:w-auto">
            <button 
              *ngFor="let period of periods"
              (click)="setPeriod(period)"
              [class.bg-white]="selectedPeriod === period"
              [class.shadow-sm]="selectedPeriod === period"
              [class.text-yellow-700]="selectedPeriod === period"
              [class.text-gray-500]="selectedPeriod !== period"
              class="flex-1 lg:flex-none px-6 py-2 rounded-lg text-sm font-bold capitalize transition-all duration-200 focus:outline-none hover:text-yellow-700">
              {{ period }}
            </button>
         </div>
      </div>

      <!-- Date Range -->
      <div class="flex flex-col sm:flex-row gap-4 w-full lg:w-auto flex-1">
        <div class="w-full space-y-2">
          <label class="text-xs font-bold text-gray-400 uppercase tracking-wider ml-1">From</label>
          <input type="date" class="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none transition-all">
        </div>
        <div class="w-full space-y-2">
          <label class="text-xs font-bold text-gray-400 uppercase tracking-wider ml-1">To</label>
          <input type="date" class="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none transition-all">
        </div>
      </div>

      <!-- Submit Action -->
      <div class="w-full lg:w-auto pb-0.5">
        <button class="w-full lg:w-auto bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-3 px-8 rounded-xl transition-all transform active:scale-95 flex items-center justify-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
          Apply
        </button>
      </div>
    </div>
  </div>

  <!-- DASHBOARD CONTENT -->
  <div *ngIf="activeSubTab === 'profits'" class="space-y-6">
    
    <!-- KPI SECTION (Updated via TS) -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <ng-container *ngFor="let item of kpiStats">
        <div class="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow group">
          <div class="flex justify-between items-start mb-4">
            <div class="p-2.5 rounded-lg transition-colors" [ngClass]="[item.bgClass, 'group-hover:bg-opacity-80']">
              <img *ngIf="item.icon?.includes('http')" [src]="item.icon" class="w-6 h-6" alt="icon" />
              <svg *ngIf="!item.icon?.includes('http')" class="w-6 h-6" [ngClass]="item.colorClass" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon"></path>
              </svg>
            </div>
            <span class="text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full">
              {{ item.trend }}
            </span>
          </div>
          <h4 class="text-gray-500 text-xs font-bold uppercase tracking-wide mb-1">
            {{ item.label }}
          </h4>
          <h2 class="text-2xl font-extrabold text-gray-800">
            {{ item.type === 'currency' ? (item.value | currency:'INR') : item.value }}
          </h2>
        </div>
      </ng-container>
    </div>

    <!-- KPI SECTION 2: Financial Summary -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
       <!-- Total Revenue -->
       <div class="bg-gray-900 p-6 rounded-2xl shadow-xl text-white relative overflow-hidden group">
         <div class="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-yellow-500 opacity-20 rounded-full blur-2xl group-hover:opacity-30 transition-opacity"></div>
         <h4 class="text-gray-400 font-medium text-sm mb-2">Total Revenue</h4>
         <h2 class="text-3xl font-bold mb-1 text-yellow-500">{{ financialSummary.revenue | currency:'INR' }}</h2>
      </div>

      <!-- Gross Profit -->
      <div class="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm flex flex-col justify-center">
         <h4 class="text-gray-500 font-bold text-sm mb-1">Gross Profit</h4>
         <div class="flex items-baseline gap-2">
            <h2 class="text-3xl font-bold text-gray-800">{{ financialSummary.grossProfit | currency:'INR' }}</h2>
            <span class="text-xs font-bold bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded">High Margin</span>
         </div>
      </div>

      <!-- Net Profit -->
      <div class="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm flex flex-col justify-center relative">
         <h4 class="text-gray-500 font-bold text-sm mb-1">Net Profit</h4>
         <h2 class="text-3xl font-bold text-gray-800">{{ financialSummary.netProfit | currency:'INR' }}</h2>
         <div class="absolute right-6 top-1/2 -translate-y-1/2 h-12 w-20 opacity-50">
            <svg class="w-full h-full text-yellow-500" stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 100 40">
              <path d="M0 35 L10 30 L20 32 L30 20 L40 25 L50 15 L60 20 L70 5 L80 10 L90 5 L100 0" />
            </svg>
         </div>
      </div>
    </div>

    <!-- BOTTOM SECTION: Charts -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
       
       <!-- Main Profit Chart -->
       <div class="lg:col-span-2 bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col">
          <div class="flex justify-between items-center mb-6">
             <h3 class="font-bold text-lg text-gray-800">Profit Trend Analysis</h3>
             <button class="text-xs font-bold text-yellow-700 hover:bg-yellow-50 px-3 py-1.5 rounded-lg transition-colors">View Report</button>
          </div>
          <div class="flex-1 min-h-[300px] relative w-full">
             <canvas #profitChart></canvas>
          </div>
       </div>

       <!-- Goal Tracker -->
       <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col">
          <h3 class="font-bold text-lg text-gray-800 mb-6">Monthly Interest Goal</h3>
          
          <div class="flex-1 flex flex-col items-center justify-center">
             <!-- Circular Progress -->
             <div class="relative w-48 h-48">
                <svg class="w-full h-full transform -rotate-90">
                   <circle cx="50%" cy="50%" r="45%" stroke="#f3f4f6" stroke-width="12" fill="none"></circle>
                   <circle cx="50%" cy="50%" r="45%" stroke="#d97706" stroke-width="12" fill="none"
                      stroke-linecap="round"
                      [style.strokeDasharray]="2 * 3.14159 * 45 + '%'" 
                      [style.strokeDashoffset]="getCircleDashOffset(goalPercentage) + '%'"
                      class="transition-all duration-1000 ease-out shadow-lg"
                   ></circle>
                </svg>
                <div class="absolute inset-0 flex flex-col items-center justify-center">
                   <span class="text-4xl font-bold text-gray-700">{{ goalPercentage }}%</span>
                   <span class="text-xs text-gray-400 font-semibold uppercase">Achieved</span>
                </div>
             </div>

             <div class="w-full mt-8 space-y-3">
                <label class="text-xs font-bold text-gray-400 uppercase tracking-wide">Set New Target</label>
                <div class="flex gap-2">
                   <div class="relative flex-1">
                      <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 font-bold text-sm">₹</span>
                      <input type="number" 
                             [(ngModel)]="targetInput" 
                             placeholder="Target Amount" 
                             class="w-full border border-gray-200 bg-gray-50 rounded-lg pl-8 pr-3 py-2.5 text-sm outline-none focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 transition-colors">
                   </div>
                   <!-- Click Event -->
                   <button (click)="updateMonthlyGoal()" 
                           class="bg-gray-800 hover:bg-gray-900 text-white px-5 py-2.5 rounded-lg font-bold text-xs uppercase tracking-wide transition-colors shadow-lg shadow-gray-200 hover:text-yellow-400 active:scale-95 transform">
                      Update
                   </button>
                </div>
             </div>
          </div>
       </div>

    </div>
  </div>
</div>